import brandImage from '../assets/biketribe-brandImage-1500.jpg';
import facebookImage from '../assets/biketribe-facebook-sharing-1200x630.jpg';
import twitterImage from '../assets/biketribe-twitter-sharing-600x314.jpg';

/////////////////////////////////////////////////////////
// Dhobara Branding Configuration                      //
/////////////////////////////////////////////////////////

// Dhobara terracotta — primary brand color
// Saved as CSS Property: --marketplaceColor in src/app.js
export const marketplaceColor = '#c05840';

// Dhobara logo served from Shopify CDN
// Logo gets 36px vertical space in the Topbar (height: 36 below)
export const logoImageDesktopURL = 'https://cdn.shopify.com/s/files/1/0746/4497/9904/files/OFFICIAL_dhobara_logo_tight.png?v=1776473057';
export const logoImageMobileURL = 'https://cdn.shopify.com/s/files/1/0746/4497/9904/files/OFFICIAL_dhobara_logo_tight.png?v=1776473057';

export const logoSettings = {
  height: 36, // increased from 24 to give logo more presence
  format: 'image',
};

// Brand image for auth pages background
export const brandImageURL = brandImage;

// Social sharing images
export const facebookImageURL = facebookImage;
export const twitterImageURL = twitterImage;
